import React, { useState, useEffect } from 'react';
import AppLoader from 'components/Loader';
import swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { deleteContributor, updateContributor } from 'redux/thunks/contributor';
import { resetDeletingContributor, resetUpdatingContributor } from 'redux/actions/contributor';
import { Button, Grid, Typography, TextField } from '@material-ui/core';
import Modal from 'components/ModalWrapper';
import './EditContributorModal.css';

const EditContributorModal = (props) => {
    const { contributor, onClose, show, siteId, dashboardId } = props;
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();
    const contributorState = useSelector((state) => state.contributor);

    useEffect(() => {
        if (contributor) {
            setFirstName(contributor.firstName);
            setLastName(contributor.lastName);
            setEmail(contributor.email);
        }
    }, [contributor]);

    useEffect(() => {
        if (contributorState.updatingContributorSuccess) {
            swal.fire({
                type: 'success',
                title: 'Success',
                text: 'Contributor updated successfully!',
                confirmButtonText: 'Ok',
            });
        }

        if (contributorState.deletingContributorSuccess) {
            swal.fire({
                type: 'success',
                title: 'Success',
                text: 'Contributor deleted successfully!',
                confirmButtonText: 'Ok',
            });
        }
    }, [contributorState.updatingContributorSuccess, contributorState.deletingContributorSuccess, dispatch]);

    const validate = () => {
        let errors = {};

        if (!firstName) {
            errors['first-name'] = '';
        }

        if (!lastName) {
            errors['last-name'] = '';
        }

        if (!email) {
            errors['email'] = '';
        }
        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleDelete = async () => {
        const result = await swal.fire({
            title: 'Are you sure?',
            text: 'This person will be removed as a contributor.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it.',
        });

        if (result.value) {
            const contributor = {
                userId: email,
                dashboardId: dashboardId,
                siteId: siteId,
            };
            dispatch(deleteContributor(contributor));
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }
        const data = {
            siteId: siteId,
            dashboardId: dashboardId,
            email: email,
            firstName: firstName,
            lastName: lastName,
        };
        dispatch(updateContributor(data));
    };

    useEffect(() => {
        if (contributorState.updatingContributorSuccess || contributorState.deletingContributorSuccess) {
            onClose();
            dispatch(resetUpdatingContributor());
            dispatch(resetDeletingContributor());
        }
    }, [contributorState.updatingContributorSuccess, contributorState.deletingContributorSuccess, onClose, dispatch]);

    return (
        <div>
            <Modal allowClickOutsideToClose open={show} height='small' onCloseClicked={onClose}>
                <Grid container direction='column' className='edit-contributor-modal'>
                    <Grid container item justifyContent='center' className='edit-contributor-modal__title'>
                        <Typography variant='h5'>Edit Contributor</Typography>
                    </Grid>

                    <Grid container direction='column' className='edit-contributor-modal__body'>
                        {contributorState.updatingContributor || contributorState.deletingContributor ? (
                            <AppLoader />
                        ) : (
                            <>
                                <TextField
                                    className='edit-contributor-modal__form-field'
                                    variant='outlined'
                                    label='First Name *'
                                    error={'first-name' in fieldErrors}
                                    helperText={'first-name' in fieldErrors && 'This field is required'}
                                    value={firstName}
                                    onChange={(event) => setFirstName(event.target.value)}
                                />

                                <TextField
                                    className='edit-contributor-modal__form-field'
                                    variant='outlined'
                                    label='Last Name *'
                                    error={'last-name' in fieldErrors}
                                    helperText={'last-name' in fieldErrors && 'This field is required'}
                                    value={lastName}
                                    onChange={(event) => setLastName(event.target.value)}
                                />
                            </>
                        )}
                    </Grid>
                    <Grid container justifyContent='space-between' className='edit-contributor-modal__footer'>
                        <div className='edit-contributor-modal__footer-buttons--left'>
                            <Button
                                color='default'
                                size='large'
                                variant='contained'
                                onClick={props.onClose}
                                className='edit-contributor-modal__footer-button--close'
                            >
                                Close
                            </Button>
                            <Button
                                color='secondary'
                                size='large'
                                variant='contained'
                                disabled={contributorState.updatingContributor}
                                onClick={handleDelete}
                                className='edit-contributor-modal__footer-button--delete'
                            >
                                Delete
                            </Button>
                        </div>
                        <Button
                            color='primary'
                            size='large'
                            variant='contained'
                            disabled={contributorState.updatingContributor}
                            onClick={handleSave}
                            className='edit-contributor-modal__footer-button--save'
                        >
                            Save Changes
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

export default EditContributorModal;
